import React from "react";

import { Provider as StoreProvider } from "react-redux";

import ThemeProvider from "./components/ThemeProvider";
import UseTermsDialog from "./components/UseTermsDialog";
import HookProvider from "./hooks/index";
import Routes from "./routes/index";
import store from "./store";

const App: React.FC = () => {
  return (
    <StoreProvider store={store}>
      <ThemeProvider>
        <HookProvider>
          <Routes />
          <UseTermsDialog />
        </HookProvider>
      </ThemeProvider>
    </StoreProvider>
  );
};

export default App;
